module.exports = __webpack_public_path__ + "static/21-03-02_11-26-18_4128-eae282bd3417b99150ce7bde88afe7ca.png";